import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withStyles } from '@mui/styles'

import lang from 'lang'
import CheckIcon from 'assets/images/icons/check.svg'
import { ModalBig } from '@/modules/base/components/modal/index'
import { Checkbox } from '@/modules/base/components/inputs/index'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons'
import { closeAddressFormModal, updateSupplierData } from '@/redux/ducks/supplier/edit'
import { CompanyFormFields, BaseFormFields } from '@/modules/base/components/forms/address-form/index'

const AddressFormModal = (props) => {
  const { onSubmit = () => { }, onCancel, classes } = props
  const dispatch = useDispatch()
  const addresses = useSelector(state => state.supplier.edit.supplier.addresses)
  const selectedAddress = useSelector(state => state.supplier.edit.selectedAddress)
  const [updatedAddress, updateAddress] = useState(selectedAddress)
  const closeModal = () => dispatch(closeAddressFormModal())
  const updateSupplier = (addresses) => dispatch(updateSupplierData({ addresses }))

  const { tempId } = selectedAddress
  const defaultAddress = addresses.find(address => address.isDefault)
  const title = tempId ? lang.supplierAddressFormModalEdit : lang.supplierAddressFormModalAdd
  const submitButtonLabel = tempId ? lang.generics.finished : lang.generics.make

  const handleFieldChange = (value, name) => {
    updateAddress({ ...updatedAddress, [name]: value })
  }
  const handleBaseFieldChange = (data) => {
    updateAddress({ ...updatedAddress, ...data })
  }

  const handleSubmitClick = () => {
    if (!updatedAddress.companyName) return

    if (!defaultAddress) {
      updatedAddress.isDefault = true
    }

    let newAddresses = addresses
    if (updatedAddress.isDefault) {
      newAddresses = addresses.map(address => ({ ...address, isDefault: false }))
    }

    const updatedAddresses = tempId
      ? newAddresses.map((existingAddress) => {
        const { tempId: existingAddressTempId } = existingAddress
        return existingAddressTempId !== tempId ? existingAddress : { ...existingAddress, ...updatedAddress }
      })
      : [...newAddresses, updatedAddress]

    updateSupplier(updatedAddresses)
    closeModal()
    onSubmit(updatedAddresses)
  }
  const handleAbortClick = () => {
    closeModal()
    onCancel && onCancel()
  }

  const actions = [
    <CancelButton key="address-form-cancel" type='button' label={lang.generics.abort} onClick={handleAbortClick} />,
    <ButtonIconSquare
      key="address-form-submit"
      type='button'
      icon={CheckIcon}
      label={submitButtonLabel}
      disabled={!updatedAddress.companyName}
      customClass={classes.submitButton}
      onClick={handleSubmitClick} />,
  ]

  return (
    <ModalBig
      open={true}
      title={title}
      actions={actions}
      onClose={handleAbortClick}>
      <div className={classes.content}>
        <form onSubmit={(e) => { e.preventDefault() }}>
          <CompanyFormFields data={updatedAddress} errors={{}} onTextInputChange={handleFieldChange} />
          <BaseFormFields data={updatedAddress} onChange={handleBaseFieldChange} />
          <Checkbox
            name='isDefault'
            checked={!defaultAddress || updatedAddress.isDefault}
            disabled={!defaultAddress || selectedAddress.isDefault}
            onChange={handleFieldChange}>
            <span className={classes.checkboxLabel}>{lang.supplierDefaultAddress}</span>
          </Checkbox>
        </form>
      </div>
    </ModalBig>
  )
}

const styles = ({
  checkboxLabel: {
    marginLeft: 15,
  },
  submitButton: {
    marginLeft: 15,
  },
})

export default withStyles(styles)(AddressFormModal)
